import React from 'react'
import Input from 'components/input'
import Button from 'components/button'

// Preset palette (Morta design tokens) shown as a responsive swatch grid.
export const PALETTE: string[] = [
  '#ffffff',
  '#f5f5f5',
  '#d9dbde',
  '#333333',
  '#2b3389',
  '#2e7ff9',
  '#59cd90',
  '#f1c744',
  '#ff4e0d',
  '#f72c60',
  '#e92aba',
  '#7c3aed',
  '#d0f0fd',
  '#e8fff3',
  '#fff3d4',
  '#f8e1f2'
]

interface ColourPickerProps {
  color: string
  onChange: (hex: string) => void
}

// A compact colour picker: a grid of preset swatches plus a hex field. It has its own width (eight
// 26px swatches), so it isn't squashed inside a pop-up that shrinks to fit its content; the swatches
// drop the Button's fixed height so they stay square.
const ColourPicker: React.FC<ColourPickerProps> = ({ color, onChange }) => {
  const selected = (color || '').toLowerCase()

  return (
    <div className="w-[248px]" data-testid="colour-picker">
      <div className="grid grid-cols-8 gap-1 border border-divider rounded-md bg-surface p-1.5">
        {PALETTE.map((swatch) => (
          <Button
            key={swatch}
            internalType="transparent"
            aria-label={`Colour ${swatch}`}
            className={`aspect-square h-auto w-full min-w-0 rounded-sm p-0 border border-divider-strong/10 ${
              selected === swatch ? 'outline outline-2 outline-blue outline-offset-1' : ''
            }`}
            style={{ backgroundColor: swatch }}
            onClick={() => onChange(swatch)}
          />
        ))}
      </div>
      <div className="mt-1.5 flex items-center gap-2">
        <span className="h-[22px] w-[22px] shrink-0 rounded border border-divider" style={{ backgroundColor: color }} />
        <Input type="text" className="w-[110px]" value={color} onChange={(event) => onChange(event.target.value)} />
      </div>
    </div>
  )
}

export default ColourPicker
